import React, {FC} from "react";
import {useHistory} from "react-router";
import {Button, Spin, message} from "antd";
import {useAuthenticateQuery, useLogoutMutation} from "../../generated/graphql";
import {RightOutlined} from "@ant-design/icons";
import {URL_ASSISTANT_CHANGELOG, URL_ASSISTANT_LOGIN} from "../../models/url";
import {ThemeMode, useAssistantTheme} from "./AssistantThemeContext";
import styles from "./assistantApp.less";

type ThemeOptionDef = {
    value: ThemeMode;
    label: string;
};

const themeOptions: ThemeOptionDef[] = [
    {value: "system", label: "System"},
    {value: "light", label: "Hell"},
    {value: "dark", label: "Dunkel"},
];

const AssistantProfile: FC = () => {
    const history = useHistory();
    const {data, loading} = useAuthenticateQuery();
    const {themeMode, setThemeMode} = useAssistantTheme();

    const [logout, {loading: loggingOut}] = useLogoutMutation({
        onCompleted: () => {
            history.replace(URL_ASSISTANT_LOGIN);
        },
        onError: (error) => {
            message.error("Abmelden fehlgeschlagen: " + error.message);
        },
    });

    const email = data?.authenticate?.email;

    if (loading) {
        return (
            <div style={{textAlign: "center", padding: 48}}>
                <Spin />
            </div>
        );
    }

    return (
        <div>
            <div className={styles.assistantSectionTitle}>{"Profil"}</div>

            {/* Account Info */}
            <div className={styles.assistantProfileSection}>
                <div className={styles.assistantProfileLabel}>{"E-Mail"}</div>
                <div className={styles.assistantProfileValue}>{email || "–"}</div>
            </div>

            {/* Theme Toggle */}
            <div className={styles.assistantProfileSection}>
                <div className={styles.assistantProfileLabel}>{"Darstellung"}</div>
                {themeOptions.map((option) => {
                    const isActive = themeMode === option.value;
                    return (
                        <div
                            key={option.value}
                            className={`${styles.assistantThemeOption} ${isActive ? styles.assistantThemeOptionActive : ""}`}
                            onClick={() => setThemeMode(option.value)}
                        >
                            <div className={`${styles.assistantThemeRadio} ${isActive ? styles.assistantThemeRadioActive : ""}`} />
                            <span>{option.label}</span>
                        </div>
                    );
                })}
            </div>

            {/* Neuigkeiten */}
            <div
                className={styles.assistantProfileSection}
                onClick={() => history.push(URL_ASSISTANT_CHANGELOG)}
                style={{cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between"}}
            >
                <div>
                    <div className={styles.assistantProfileLabel}>{"App-Info"}</div>
                    <div style={{fontSize: 15, color: "var(--aa-text-primary)"}}>{"Neuigkeiten & Änderungen"}</div>
                </div>
                <RightOutlined style={{color: "var(--aa-text-tertiary)", fontSize: 14}} />
            </div>

            {/* Logout */}
            <div style={{marginTop: 24}}>
                <Button
                    block
                    size="large"
                    onClick={() => logout()}
                    loading={loggingOut}
                    style={{
                        borderRadius: 10,
                        height: 48,
                        fontSize: 16,
                        borderColor: "var(--aa-danger)",
                        color: "var(--aa-danger)",
                    }}
                >
                    {"Abmelden"}
                </Button>
            </div>
        </div>
    );
};

export default AssistantProfile;
